import React from "react";
import { connect } from "react-redux";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../../../../store/AppDisplays";
import { isRemoteLoading, ReduxState } from "../../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { Filter } from "../../../../02-pages/Filter";
import { Results } from "../../../../02-pages/Results";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { Products } from "../../../../../../../store/Product/Types";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: Products;
}

type Props = StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.PRODUCT_RESULTS),
    results: s.prop("remote").prop(RemoteScope.PRODUCT_RESULTS),
});

/**
 *
 * @param props
 */
export class ProductsAuditTrailComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Header
                        title={SubPageDisplay[SubPages.AUDIT_TRAIL_PRODUCTS].title}
                        description={SubPageDisplay[SubPages.AUDIT_TRAIL_PRODUCTS].description}
                        goBack={PageDisplay[Pages.AUDIT_TRAILS].path}
                    />
                    <Filter
                        loadingFilters={this.props.loadingFilters}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.PRODUCT}
                    />
                    <Results
                        results={this.props.results}
                        loadingResults={this.props.loadingResults}
                        currentPage={SubPages.AUDIT_TRAIL_PRODUCTS}
                        scope={RemoteScope.PRODUCT_RESULTS}
                    />
                </Container>
            </Page>
        );
    }
}

/**
 *
 */
export const ProductsAuditTrail = connect(
    mapStateToProps,
    {},
)((props: Props) => <ProductsAuditTrailComp {...props}/>);
